import { render, staticRenderFns } from "./custom-company-header.vue?vue&type=template&id=42165db8&scoped=true&"
import script from "./custom-company-header.vue?vue&type=script&lang=js&"
export * from "./custom-company-header.vue?vue&type=script&lang=js&"
import style0 from "./custom-company-header.vue?vue&type=style&index=0&id=42165db8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42165db8",
  null
  
)

export default component.exports